import React, {Component} from 'react';
import {Progress} from 'antd';

class ProgressForTable extends Component {

    render() {
        const { percent, level } = this.props;

        return (
            <div className="progress-for-table">
                { percent !== undefined &&
                level !== undefined && (
                    <div className={level.toLowerCase()}>
                        <Progress percent={percent >= 100 ? 100 : percent} strokeWidth={5}
                                  status="active" format={() => `${percent}%`}/>
                    </div>
                )}
            </div>
        );
    }
}

export default ProgressForTable;


// WEBPACK FOOTER //
// ./src/modules/system-usage/ProgressForTable.js